import React, { useEffect, useState } from 'react';
import { Page, PDFViewer, PDFDownloadLink, Text, View, Document, StyleSheet, Image, Font, } from '@react-pdf/renderer';


import { dateLanguage, fullDate } from '../../../../utils/date';
import { useParams } from 'react-router-dom';
import api from '../../../../services/api';
import { useConfiguration } from '../../../../hooks/Configuration';
import { useAuth } from '../../../../hooks/Auth';
import { loadFromJson } from 'src/utils/loadFromJson';
import { hash as hashApp } from 'src/config';
Font.register({
  family: 'Montserrat',
  fonts: [
    { src: '/assets/fonts/Montserrat-Regular.ttf' },
    { src: '/assets/fonts/Montserrat-Bold.ttf', fontStyle: 'bold' }
  ]

});


interface IProps {
  hash?: string;
  projectHash?: string;
}

interface IRecibo {
  name: string;
  document_number: string;
  sale_hash: string;
  total: number;
  payment_date: Date;
  createdAt: Date;
  projeto: string;
  payer_type: string;
  product: string;
  razao_social: string;
    cnpj: string;
}

export const ConfirmacaoInscricao: React.FC<IProps> = ( ) => {
  const [recibo, setRecibo] = useState<Record<string, any>>({} as Record<string, any>);
  const [project, setProject] = useState<Record<string, any>>({} as Record<string, any>);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [notPaid, setNotPaid] = useState(false);

  const { configuration } = useConfiguration();
  const { user } = useAuth();
const projectHash = configuration?.url;
const {hash} = useParams<any>();

  const load = async () => {


    const response = await api.get(`/my-qrcodes/${projectHash}`, { params: { where: { ticket_hash: hash, project_id: projectHash } } });
    const projectInfo = configuration;

    if (response?.data?.rows?.[0]?.payment_status_id !== 'paid') {
      setFailed(true);
      setLoading(false);
      setReady(true);
    }
    else {


       const item = await loadFromJson({ hash: hashApp, project_id: 'global', table: 'Global' });
              const config = item?.[0];

                 const reciboInfo = response?.data?.rows?.[0];
reciboInfo.razao_social = config?.company_name;
    reciboInfo.cnpj = config?.company_document;


      setRecibo(reciboInfo);
      setProject(projectInfo);
      setLoading(false);
      setReady(true);
    }

  }

  const loadProfile1 = async () => {


    const response = await api.get(`/sales-products`, { params: { where: { ticket_hash: hash, project_id: projectHash } } });
    const projectInfo = configuration;

    if (response?.data?.rows?.[0]?.payment_status_id !== 'paid') {
      setFailed(true);
      setLoading(false);
      setReady(true);
    }
    else {

    const item = await loadFromJson({ hash: hashApp, project_id: 'global', table: 'Global' });
              const config = item?.[0];

           

                 const reciboInfo = response?.data?.rows?.[0];
reciboInfo.razao_social = config?.company_name;
    reciboInfo.cnpj = config?.company_document;


      setRecibo(reciboInfo);
      setProject(projectInfo);
      setLoading(false);
      setReady(true);
    }

  }

  useEffect(() => { 
    if (configuration && hash) {
     
      if (user?.profile === 1) {

        loadProfile1()

      }
      else {
        load();
      }
    }
  }, [configuration, hash, user])

  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#fff",
      color: "#333",
      padding: '20px'
    },
    section: {
      margin: 10,
      padding: 10,
    },
    viewer: {
      width: window.innerWidth, //the pdf viewer will take up all of the width and height
      height: window.innerHeight,
    },
  });

  if (notPaid) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h2>O pagamento não foi identificado</h2><br /><br />
      <p style={{ textAlign: 'center' }}> <strong>Protocolo da compra:</strong><br /> {hash}</p>
    </div >
  }

  if (failed) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
      <h2>Compra não identificada.</h2><br /><br />
      <p style={{ textAlign: 'center' }}><strong>Protocolo da compra:</strong> <br />{hash}</p>
    </div >
  }



  if (loading) {
    return <div className='shadow' style={{ background: '#fff', borderRadius: '15px', color: '#000', margin: '20px auto', width: '100%', maxWidth: '400px', padding: '30px', minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <h2>Verificando...</h2>
    </div >
  }

  if (ready && configuration) {
    return <>
      <PDFDownloadLink fileName='recibo.pdf' document={
        <Document >
          {/*render a single page*/}
          <Page size="A4" style={styles.page}>

            <View>  <Image style={{ width: '150px' }} src="/apoio/logo-padrao.png" />
            </View>

            <View style={{ borderTop: '1px solid #000', marginTop: '15px', paddingTop: '20px' }}>
              <Text style={{ fontWeight: 'bold', fontSize: '24px', margin: '30px auto', textAlign: 'center', width: '100%' }}>CONFIRMAÇÃO DE INSCRIÇÃO</Text>
              <Text style={{ fontWeight: 700, fontSize: '10px', textAlign: 'center', marginBottom: '30px', width: '100%' }}>Chave de controle: {recibo.ticket_hash}</Text>
            </View>


            <View style={styles.section}>
              <Text style={{ fontSize: '14px' }}>{`A ${recibo?.razao_social}, CNPJ ${recibo?.cnpj},  confirma a inscrição de ${recibo.client_id_response?.name} na modalidade ${recibo.product_id_response?.title} do evento ${project?.title}.`}</Text>
            </View>
            <View style={{ width: '100%', textAlign: 'right', fontSize: '14px', marginTop: '60px' }}>
              <Text>Porto alegre, {fullDate(recibo.payment_date || recibo?.createdAt)}</Text>
            </View>


            
          </Page>
        </Document>


      }>
        <button className='defaultButton'> Realizar Download da Confirmação de Inscrição </button>
      </PDFDownloadLink>


      <aside className='computerOnly' style={{ width: '100%' }}>
        <PDFViewer style={{
          width: window.innerWidth, //the pdf viewer will take up all of the width and height
          height: window.innerHeight,
        }}>
          <Document >
            {/*render a single page*/}
            <Page size="A4" style={styles.page}>

              <View>  <Image style={{ width: '150px' }} src="/apoio/logo-padrao.png" />
              </View>

              <View style={{ borderTop: '1px solid #000', marginTop: '15px', paddingTop: '20px' }}>
                <Text style={{ fontWeight: 'bold', fontSize: '24px', margin: '30px auto', textAlign: 'center', width: '100%' }}>CONFIRMAÇÃO DE INSCRIÇÃO</Text>
                <Text style={{ fontWeight: 700, fontSize: '10px', textAlign: 'center', marginBottom: '30px', width: '100%' }}>Chave de controle: {recibo.sale_hash}</Text>
              </View>


              <View style={styles.section}>
                <Text style={{ fontSize: '14px' }}>{`A ${recibo?.razao_social}, CNPJ ${recibo?.cnpj}, confirma a inscrição de ${recibo.client_id_response?.name} na modalidade ${recibo.product_id_response?.title} no evento ${project?.title}.`}</Text>
              </View>
              <View style={{ width: '100%', textAlign: 'right', fontSize: '14px', marginTop: '60px' }}>
                <Text>Porto Alegre, {fullDate(recibo?.payment_date || recibo?.createdAt)}</Text>
              </View>



            </Page>
          </Document>
        </PDFViewer>
      </aside>
    </>
  }

  return <></>
}